module.exports = __webpack_public_path__ + "static/media/excel.70a065ff.svg";